define('podcast',['jquery', 'underscore', 'event-manager'], function($, _, eventManager) {
    'use strict';

    var podcast = {
        init: function() {
            // Open shareables in new window
            $('.sharable').click(function(e) {
                e.preventDefault();
                window.open(e.currentTarget.getAttribute('href'), 'share', 'width=720,height=275,resizable,scrollbars=no,status=1');
            });

            $('.list-header').click(function() {
                $(this).parent().toggleClass('closed');
            });
        },
    };

    eventManager.on('e24-podcast-loaded', function() {
        podcast.init();
    });
});

